export const LOGIN_SET_LOADING_STATE = 'LOGIN_SET_LOADING_STATE';
export const LOGIN_SET_USER_ID = 'LOGIN_SET_USER_ID';
export const LOGIN_SET_ERROR = 'LOGIN_SET_ERROR';
export const LOGIN_RESET_ERROR = 'LOGIN_RESET_ERROR';
export const LOGIN_RESET_USER_DATA = 'LOGIN_RESET_USER_DATA';
